<template lang="pug">
v-layout(row wrap)
  v-flex(xs12 md6 lg4 v-for="category in content.categories" :key="category.id")
    v-card
      v-img(v-if="category.media" @click="goTo(category)" :src="category.media" :aspect-ratio="16/9")
      v-card-title.subheading: router-link(:to="`/${category.slug}`") {{category.name}}

</template>

<script>

export default {
  props: ['extra'],
  data() {
    return {
      open: true,
      open2: true,
      content: {}
    }
  },
  watch: {
    extra: {
      handler(val) {
        this.content = JSON.parse(this.extra && this.extra.content || null)
      },
      immediate: true,
    }
  },
  methods: {
    goTo(category) {
      if (category.slug) {
        this.$router.push(`/${category.slug}`)
      }
    }
  }
}
</script>
